__turbopack_context__.v({
  "bento-content": "FeatureBentoSection-module__x0-vVq__bento-content",
  "bg-grad-blue": "FeatureBentoSection-module__x0-vVq__bg-grad-blue",
  "caption": "FeatureBentoSection-module__x0-vVq__caption",
  "cardElement": "FeatureBentoSection-module__x0-vVq__cardElement",
  "description": "FeatureBentoSection-module__x0-vVq__description",
  "fadeInUp": "FeatureBentoSection-module__x0-vVq__fadeInUp",
  "fadeOutDown": "FeatureBentoSection-module__x0-vVq__fadeOutDown",
  "full-width": "FeatureBentoSection-module__x0-vVq__full-width",
  "lg": "FeatureBentoSection-module__x0-vVq__lg",
  "overlay": "FeatureBentoSection-module__x0-vVq__overlay",
  "root": "FeatureBentoSection-module__x0-vVq__root" + " " + __turbopack_context__.i(905307)["sectionPadding"],
  "uhx-text-content": "FeatureBentoSection-module__x0-vVq__uhx-text-content",
  "w-full": "FeatureBentoSection-module__x0-vVq__w-full",
  "xl": "FeatureBentoSection-module__x0-vVq__xl",
});
